import 'firebase/app';
import 'firebase/auth';
import { Feedback } from "./feedback";
import { AdditionalUserInfo, getAdditionalUserInfo, GoogleAuthProvider, OAuthCredential, TwitterAuthProvider, UserCredential } from 'firebase/auth';

/**
 * This is the authenticated details for the logged in user.
 */
export class User {
    provider: string = "";
    displayName: string = "";
    email: string = "";
    emailVerified: Boolean = false;
    photoUrl: string = "";
    accessToken: string = "";
    token: string = "";
    refreshToken: string = "";
    userId: string = "";
    paths?: Object[];
    feedbacks: Feedback[] = []; //Contain two properties: rating and message
    subscription = {
        createdDate: new Date(),
        plan: 'Free'
    };

    public constructor(userId: string, displayName?: string, email?: string, 
            token?: string, refreshToken?: string, emailVerified?: Boolean, 
            photoUrl?: string, provider?: string, subscription?: any) {
        
        this.userId = userId;
        this.displayName = displayName || '';
        this.email = email || '';
        this.token = token || '';
        this.refreshToken = refreshToken || '';

        if(!! emailVerified) {
            this.emailVerified = emailVerified;
        }
        if(!! photoUrl) {
            this.photoUrl = photoUrl;
        }
        if(!! provider) {
            this.provider = provider;
        }

        if(!! subscription) {
            this.subscription = {
                ...subscription
            };
        } 
    }

    public setPaths(paths: any[]) {
        this.paths = paths;
    }

    public static From(creds: UserCredential | any, info: AdditionalUserInfo): User {
        const usr = creds.user;
        // const tkens: OAuthCredential | null = GoogleAuthProvider.credentialFromResult(creds);
        console.log("Converting fb user -> user");
        return new User(
            usr.uid,
            usr.displayName || '',
            usr.email || '',
            usr?.accessToken,
            usr.refreshToken,
            usr.emailVerified,
            usr.photoURL || '',
            usr.providerId,
            (usr as any)['subscription'] || null
        );
    }
}


export class Twitter {
    public static From(creds: UserCredential | any, info: AdditionalUserInfo): User {
        const usr = creds.user;
        // const tkens: OAuthCredential | null = TwitterAuthProvider.credentialFromResult(creds);
        console.log("Converting fb user -> user");
        return new User(
            usr.uid,
            usr.displayName || '',
            usr.email ?? '',
            usr?.accessToken,
            usr.refreshToken,
            usr.emailVerified,
            usr.photoURL || '',
            info?.providerId || '',
            (usr as any)['subscription'] ?? null
        );
    }
}

const strategies = {
    ['twitter.com']: Twitter.From,
    ['google.com'] : User.From
};

export function createUser(creds: UserCredential | any) {
    const info = creds.additionalUserInfo ?? getAdditionalUserInfo(creds);
    const type = info?.providerId || '';
    const strategyConverter = (strategies as any)[type];
    if(!strategyConverter) throw new Error("Invalidate type: " + type);
    return strategyConverter(creds, info);
}